import * as t from "io-ts"

const Device = t.type({
    type: t.string,
    systemReference: t.string,
    status: t.string,
    dataset: t.string,
})

const DeviceAlert = t.type({
    raisedAt: t.string,
    deviceSystemRef: t.string,
    description: t.string,
    alerterUsername: t.string,
    dataset: t.string,
})

export const SysAdminDevicesData = t.type({
    topCompliantSummary: t.array(Device),
    topLiveAlerts: t.array(DeviceAlert),
    topAwaitingAssessmentSummary: t.array(Device),
    totDevicesAwaitingAssessment: t.number,
    totLiveAlerts: t.number,
})

export type ISysAdminDevicesData = t.TypeOf<typeof SysAdminDevicesData>
